
// 采用 Intl 库处理 DateTimeFormat 兼容问题
export default async function dayjsPolyfill() {
  try {
    if (typeof window.Intl?.DateTimeFormat?.prototype?.formatToParts === 'function') return;
    let IntlPolyfill = await import(
      //@ts-ignore
      /* webpackChunkName: "dayjs-polyfill-intl" */ 'intl/dist/Intl.min'
    ) as any;
    if (IntlPolyfill?.__esModule) { IntlPolyfill = IntlPolyfill.default; }
    const IntlLocaleEsUS = await import(
      /* webpackChunkName: "dayjs-polyfill-intl" */ './locale-data/es-US.json'
    );
    window.Intl = IntlPolyfill;
    IntlPolyfill.__addLocaleData(IntlLocaleEsUS);
    IntlPolyfill.__applyLocaleSensitivePrototypes();
    IntlPolyfill.__disableRegExpRestore();
  } catch (e) {
    console.error(e);
  }
}

// import {shouldPolyfill} from '@formatjs/intl-datetimeformat/should-polyfill';

// 采用 @formatjs/intl-datetimeformat 库处理 DateTimeFormat 兼容问题
// export default async function dayjsPolyfill() {
//   if (typeof window.Intl?.DateTimeFormat?.prototype?.formatToParts === 'function') return;
//   // const unsupportedLocale = shouldPolyfill(locale);
//   // This locale is supported
//   // if (!unsupportedLocale) {
//   //   return
//   // }
//   try {
//     // Load the polyfill 1st BEFORE loading data
//     await import(/* webpackChunkName: "dayjs-polyfill-formatjs" */ '@formatjs/intl-datetimeformat/polyfill-force');

//     // Parallelize CLDR data loading
//     const dataPolyfills = [
//       import(/* webpackChunkName: "dayjs-polyfill-formatjs" */ '@formatjs/intl-datetimeformat/add-golden-tz'),
//       import(/* webpackChunkName: "dayjs-polyfill-formatjs" */ `@formatjs/intl-datetimeformat/locale-data/es-US`),
//     ];

//     await Promise.all(dataPolyfills);
//   } catch (e) {}
// }
